import { useNavigate } from "react-router-dom";
import { useSidebar } from "./sidebar/sidebar.context";

export function ClickHandleNavigate() {
  const { onClickParentMenu, childMenuOpen } = useSidebar();
  const navigate = useNavigate();

  const onClickHandleNavigate = (url, childOpen) => {
    navigate(url);
    if (childMenuOpen.includes(childOpen)) return;
    onClickParentMenu(childOpen);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const containerStyle =
    "min-w-[320px] max-w-[320px] sm:min-w-[90%] mx-2 sm:w-[78%] border border-ys-pewter-600 hover:border-ys-pewter-700 cursor-pointer mt-4";

  const bgColor = "bg-tertiary-50 bg-opacity-80 hover:bg-opacity-100";

  return { onClickHandleNavigate, scrollToTop, containerStyle, bgColor };
}
